function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  width: 1.077,
  height: 10.236,
  rx: 0.539,
  transform: "rotate(-44.999 .92 .38)",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 1.077,
  height: 10.236,
  rx: 0.539,
  transform: "rotate(-135.001 2.038 3.842)",
  fill: "#fff"
});

function SvgBadgeCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgBadgeCross;